module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJ1BMVEUAAAD///////////////////////////////////////////////+uPUo5AAAADHRSTlMAQL+AblXq35+SEwhMByGLAAAAdElEQVQI1zWNMQ6DQAwE1yZVdMWFtBRGaSlOqfkJLSWP4UlwgKDwo1idxFhrrWVrDSIRhdr9B6L5U/WJpueiytTGm6GJ0CSdH2oIKbR6yIKGJZfsxbxPWRGiWu2TQU08f0fmr8+LLnGimMgkA/m7tyi8ZrYbKmkWGOAZBFcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/Bottom/img2.png
// module id = ulIx
// module chunks = 41